module.exports = __webpack_public_path__ + "static/messages_volejball-dd7b86f14e71459364a2ca6ac77d6263.mp4";